import { darken } from 'polished'
import { useState } from 'react'
import styled, { keyframes } from 'styled-components'

const Wrapper = styled.button<{
  isActive?: boolean
  activeElement?: boolean
  size?: number
  useAlternateBackground?: boolean
}>`
  align-items: center;
  background: ${({ theme, useAlternateBackground }) =>
    useAlternateBackground ? theme.cardSecondary : theme.cardPrimary};
  border: none;
  border-radius: ${({ size = 24 }) => `${size * 0.83}px`};
  cursor: pointer;
  display: flex;
  outline: none;
  /* padding: 0.4rem 0.4rem; */
  padding: 0;
  width: fit-content;
`

const turnOnToggle = keyframes`
  from {
    margin-left: 0em;
    margin-right: 1.5em;
  }
  to {
    margin-left: 1.5em;
    margin-right: 0em;
  }
`

const turnOffToggle = keyframes`
  from {
    margin-left: 1.5em;
    margin-right: 0em;
  }
  to {
    margin-left: 0em;
    margin-right: 1.5em;
  }
`

const ToggleElementHoverStyle = (hasBgColor: boolean, theme: any, isActive?: boolean) =>
  hasBgColor
    ? {
        opacity: '0.8',
      }
    : {
        background: isActive ? darken(0.05, theme.deprecated_primary1) : darken(0.05, theme.deprecated_bg4),
        color: isActive ? theme.deprecated_white : theme.deprecated_text3,
      }

const ToggleElement = styled.span<{
  isActive?: boolean
  bgColor?: string
  isInitialToggleLoad?: boolean
  size?: number
}>`
  animation: 0.1s
    ${({ isActive, isInitialToggleLoad }) => (isInitialToggleLoad ? 'none' : isActive ? turnOnToggle : turnOffToggle)}
    ease-in;
  background: ${({ theme, bgColor, isActive }) =>
    isActive ? bgColor ?? theme.deprecated_primary1 : bgColor ? theme.deprecated_bg4 : theme.deprecated_text3};
  border-radius: 50%;
  height: ${({ size = 24 }) => `${size}px`};
  width: ${({ size = 24 }) => `${size}px`};

  :hover {
    ${({ bgColor, theme, isActive }) => ToggleElementHoverStyle(!!bgColor, theme, isActive)}
  }
  margin-left: ${({ isActive }) => (isActive ? '1.5em' : '0em')};
  margin-right: ${({ isActive }) => (!isActive ? '1.5em' : '0em')};
`

interface ToggleProps {
  id?: string
  bgColor?: string
  isActive: boolean
  toggle: () => void
  size?: number
  useAlternateBackground?: boolean
}

export default function Toggle({
  id,
  bgColor,
  isActive,
  toggle,
  size = 24,
  useAlternateBackground = false,
}: ToggleProps) {
  const [isInitialToggleLoad, setIsInitialToggleLoad] = useState(true)

  const switchToggle = () => {
    toggle()
    if (isInitialToggleLoad) setIsInitialToggleLoad(false)
  }

  return (
    <Wrapper
      id={id}
      isActive={isActive}
      onClick={switchToggle}
      size={size}
      useAlternateBackground={useAlternateBackground}
    >
      <ToggleElement isActive={isActive} bgColor={bgColor} isInitialToggleLoad={isInitialToggleLoad} size={size} />
    </Wrapper>
  )
}
